import React, { useEffect, useState } from 'react'
import { useForm, ValidationError } from '@formspree/react';

function Contact() {
    const [state, handleSubmit] = useForm("mvgkladn");
    const [formSubmitted, setFormSubmitted] = useState(false);
    useEffect(() => {
        if (state.succeeded) {
            setFormSubmitted(true);
        }
    }, [state.succeeded]);
    if (formSubmitted) {
        return (
            <div className="text-center font-bold py-6 px-6 bg-black text-white">
                <p>Email sent successfully!</p>
                <p>
                    <button className="text-white
  bg-orange-500
  hover:bg-orange-700
  active:bg-orange-700 disabled:bg-gray-400 inline-block mt-3 rounded-lg px-8 py-3 text-center text-sm font-semibold" onClick={() => setFormSubmitted(false)}>Back to form</button>
                </p>
            </div>
        )
    }
   else return (
        <div>
            <div
                id="form-ZKmOET"
                className="bg-black font-energetic px-4 py-10 sm:px-6 lg:px-8 lg:py-14 "
            >
                <div className="mx-auto max-w-screen-2xl px-4 md:px-8" data-aos="zoom-in-up">
                    <div className="mb-10 md:mb-16">
                        <h2 className="mb-4 text-center text-2xl font-bold text-white md:mb-6 lg:text-3xl">
                            Contact Radio O
                        </h2>
                    </div>
                    <form onSubmit={handleSubmit} className="mx-auto grid max-w-screen-md gap-4 sm:grid-cols-2">
                        <div data-aos="flip-left">
                            <label
                                htmlFor="name"
                                className="mb-2 inline-block text-sm text-gray-400 sm:text-base"
                            >
                                Your Name
                            </label>
                            <input
                                className="w-full rounded border bg-black text-gray-400 ring-orange-300 px-3 py-2 outline-none transition duration-100 focus:ring"
                                name="name"
                                id="name"
                                type="text"
                                required
                            />
                        </div>
                        <div data-aos="flip-right">
                            <label
                                htmlFor="email"
                                className="mb-2 inline-block text-sm text-gray-400 sm:text-base"
                            >
                                Email Address
                            </label>
                            <input
                                className="w-full rounded border bg-black text-gray-400 ring-orange-300 px-3 py-2 outline-none transition duration-100 focus:ring"
                                name="email"
                                type="email"
                                id="email"
                                required
                            />
                        </div>
                        <div className="sm:col-span-2" data-aos="flip-up">
                            <label
                                htmlFor="message"
                                className="mb-2 inline-block text-sm text-gray-400 sm:text-base"
                            >
                                Message
                            </label>
                            <textarea
                                name="message"
                                className="h-64 w-full rounded border bg-black text-gray-400 ring-orange-300 px-3 py-2 outline-none transition duration-100 focus:ring"
                                id='message'
                                required
                            />
                            <ValidationError
                                prefix="Message"
                                field="message"
                                type="text"
                                errors={state.errors}
                            />
                        </div>
                        <div className="flex items-center justify-between sm:col-span-2">
                            <button
                                type="submit" disabled={state.submitting}
                                id="send-button"
                                className="
  text-white
  bg-orange-500
  hover:bg-orange-700
  active:bg-orange-700 disabled:bg-gray-400 inline-block rounded-lg px-8 py-3 text-center text-sm font-semibold outline-none transition duration-100 focus-visible:ring md:text-base"
                            >
                                Send Message
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact